"use strict";

import "angular";
import "angular-resource";
import "angular-ui-router";
import PrimaryPlanSelectionCtrl from "./PrimaryPlanSelectionCtrl";
import PrimaryPlanSelectionFactory from "./PrimaryPlanSelectionFactory";
import LinkedConfirmationController from "./LinkedConfirmationController";
import LinkedConfirmationFactory from "./LinkedConfirmationFactory";
import LinkablePlansFactory from "./LinkablePlansFactory";
import OneIdMfaFactory from "./OneIdMfaFactory";
import LinkablePlansSelectionController from "./LinkablePlansSelectionController";
import OneIdMfaController from "./OneIdMfaController";
import OneIdRoute from "./OneIdRoute";

// eslint-disable-next-line no-undef
var OneIdModule = angular.module("OneIdModule", ["ngResource", "ui.router"]);

OneIdModule.factory("LinkablePlansFactory", LinkablePlansFactory);
OneIdModule.controller("LinkablePlansSelectionController", LinkablePlansSelectionController);
OneIdModule.controller("OneIdMfaController", OneIdMfaController);
OneIdModule.controller("PrimaryPlanSelectionCtrl", PrimaryPlanSelectionCtrl);
OneIdModule.factory("OneIdMfaFactory", OneIdMfaFactory);
OneIdModule.factory("PrimaryPlanSelectionFactory", PrimaryPlanSelectionFactory);
OneIdModule.controller("LinkedConfirmationController", LinkedConfirmationController);
OneIdModule.factory("LinkedConfirmationFactory", LinkedConfirmationFactory);
OneIdModule.config(OneIdRoute);

export default OneIdModule;
